import { Icon, Balloon } from '@alifd/next';
import * as React from 'react';
import cns from 'classnames';
import { createElement } from 'react';
import './index.scss';
const RemoteIcon = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2535522_4oyyibdwj5v.js',
});
export const CustomIcon = (props) => {
    const { type, ...otherProps } = props;
    return createElement(RemoteIcon, { type: `icon${type}`, ...otherProps });
};
const { Tooltip } = Balloon;
export const ToggleIconGroup = ({ className, ...props }) => createElement("div", { className: cns('toggle-icon-group', className), ...props });
export const ToggleIcon = React.forwardRef(({ title, active, type, size, className, ...props }, ref) => {
    const trigger = (createElement("span", { ref: ref, ...props, className: cns('toggle-icon', {
            'toggle-icon--active': active,
        }, className) },
        createElement(CustomIcon, { type: type, size: size })));
    if (!title)
        return trigger;
    return createElement(Tooltip, { trigger: trigger }, title);
});
ToggleIcon.defaultProps = {
    size: 'small',
};
